export default function formatNumber (value: number) {
  const _value = value + ''
  if (_value.includes('.')) {
    return _value.slice(0, -3).replace(/(\d)(?=(\d{3})+$)/g, '$1,') + _value.slice(-3)
  }
  return _value.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
}
